import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";

const KEY = "solkids-wishlist-v1";

const readInitial = () => {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    console.warn("Wishlist: couldn't read from localStorage", e);
    return [];
  }
};

const Ctx = createContext(null);

export function AppProvider({ children }) {
  // Read sync from localStorage on first render — survives React.StrictMode double-mount.
  const [wishlist, setWishlist] = useState(readInitial);
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(wishlist));
    } catch (e) {
      console.warn("Wishlist: couldn't persist to localStorage", e);
    }
  }, [wishlist]);

  const toggleWish = useCallback((slug) => {
    setWishlist((w) => (w.includes(slug) ? w.filter((s) => s !== slug) : [...w, slug]));
  }, []);

  const isWished = useCallback((slug) => wishlist.includes(slug), [wishlist]);

  const value = useMemo(
    () => ({ wishlist, toggleWish, isWished, navOpen, setNavOpen }),
    [wishlist, toggleWish, isWished, navOpen]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useApp = () => {
  const v = useContext(Ctx);
  if (!v) throw new Error("useApp must be used inside AppProvider");
  return v;
};
